import userService from './user-service';
import { globalVariables } from '../global';
import { escapeForRegex } from '../utils';
import { DEFAULT_PERMISSION_PREFIX } from '../constants';

/**
 * Service for validate permission
 *
 * @class PermissionService
 */
class PermissionService {
  /**
   * Static function to decide whether a action in certain route is available.
   *
   * @static
   * @param {*} route a route that user wants to access
   * @param {*} [action=null] a action that user takes, null means access only
   * @param {*} [permissionPrefix=defaultPrefix] the permission prefix
   * @returns
   * @memberof PermissionService
   */
  static has(route, action = null, permissionPrefix = DEFAULT_PERMISSION_PREFIX) {
    if (process.env.REACT_APP_SKIP_AUTH) {
      return true;
    }
    if (userService.isLoggedIn()) {
      // all logged in user has base path permission
      if (isRootPath(route)) {
        return true;
      }
      const { allow } = userService.getCurrentUser();
      return Object.keys(allow).some((resource) => {
        // all permission must start with the same prefix
        if (!resource.startsWith(permissionPrefix)) {
          return false;
        }
        const validResource = resource.substr(permissionPrefix.length);
        const routeRegex = generateRoutePermissionRegex(validResource);
        if (routeRegex.test(route)) {
          if (!action) {
            return true;
          }
          return allow[resource].any || allow[resource][action];
        }

        return false;
      });
    }
    return false;
  }
}

const getFullMatchSuffix = (regexStr) => (regexStr.length > 0 ? '\\b' : '');

const isRootPath = (route) => {
  if (route === '/') {
    return true;
  }
  const splitRoute = route.split('/');
  return splitRoute.length === 4;
};

/**
 * generate regex to validate route permission
 *
 * @param {*} irpmResource iRPM role resource
 * @returns regex
 */
const generateRoutePermissionRegex = (irpmResource) => {
  let regexStr = irpmResource;
  let suffix = '$';
  // resource ends with *, not match the remaining path
  if (regexStr.endsWith('/*') || regexStr.endsWith('/*/')) {
    regexStr = regexStr.slice(0, regexStr.endsWith('/*') ? -2 : -3);
    suffix = getFullMatchSuffix(regexStr);
  }
  regexStr = escapeForRegex(regexStr);
  // resouce contains *, matching any character one to many times
  regexStr = regexStr.replace(/\\\*/g, '.+');
  return new RegExp(`^${regexStr}${suffix}`);
};

export default PermissionService;
